module.exports = __webpack_public_path__ + "static/media/AvertaStd-Regular.62479015.woff2";